import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-finalitfacilityrequestform',
  templateUrl: './finalitfacilityrequestform.component.html',
  styleUrls: ['./finalitfacilityrequestform.component.scss']
})
export class FinalitfacilityrequestformComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router,public Toastr:ToastrService) { }
public finalitfacilityData:any=[];
  
  onApprove(){
  this.finalitfacilityData.status='Approved';
  this.finalitfacilityData.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/update_Finalitfacility?empid="+this.finalitfacilityData.OD_EmployeeID+"&status="+this.finalitfacilityData.status+"&username="+this.finalitfacilityData.approvedby).subscribe((res:any)=>{
    this.Toastr.success("Approved successfully!");
    this.appservice.get_finalItFacilitygrid();
   });
  this.appservice.checkeritfacilityedit='';
 this.appservice.goback();
}
onDecline(){
  this.finalitfacilityData.status='Rejected';
  this.finalitfacilityData.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/update_Finalitfacility?empid="+this.finalitfacilityData.OD_EmployeeID+"&status="+this.finalitfacilityData.status+"&username="+this.finalitfacilityData.approvedby).subscribe((res:any)=>{
  this.Toastr.success("Rejected successfully!");
    this.appservice.get_finalItFacilitygrid();
    });
  this.appservice.goback();
} 
back(){
  this.appservice.goback();
}
//public finalitfacilityData:any=[];
public finalitfacility_edit:any=[];
 getchecker_itfacility_edit(data:any){
   this.appservice.getTable("api/Transaction/get_finalItfacilityedit?empid="+this.appservice.FinalItfacilityeditid).subscribe((res:any)=>{
    this.finalitfacility_edit=JSON.parse(res).record;
    if(this.finalitfacility_edit && this.finalitfacility_edit.length>0){
      let emp = this.finalitfacility_edit[0];
      this.finalitfacilityData.OD_EmployeeID=emp.IR_EmployeeId;
      this.finalitfacilityData.Fullname=emp.IR_Fullname;
      this.finalitfacilityData.Username=emp.IR_ADUserName;
      this.finalitfacilityData.Mailid=emp.IR_ADMailId;
      this.finalitfacilityData.Designation=emp.IR_Designation;
      this.finalitfacilityData.grade=emp.IR_Grade;
      this.finalitfacilityData.department=emp.IR_Department;
      this.finalitfacilityData.AssertType= emp.IR_AssertType;
      this.finalitfacilityData.DriveAccess=emp.IR_NacDriver_Access;
      this.finalitfacilityData.Dongle=emp.IR_Dongle_SimCard;
      this.finalitfacilityData.MSimcard=emp.IR_Mobilesim;
      this.finalitfacilityData.Biometric=emp.IR_Biometric_card;
      this.finalitfacilityData.DoorAccess=emp.IR_DoorAccess;
      this.finalitfacilityData.Other=emp.IR_Other;
      
    }
   })
}
ngOnInit(): void {
  this.getchecker_itfacility_edit(this.appservice.FinalItfacilityeditid);
  }

}
